module.exports = __webpack_public_path__ + "static/media/pt-30.9496165a.svg";